import components from './components';
import auth from './features/auth';
import gettingReady from './features/getting-ready';
import noTeam from './features/no-team';
import platform from './features/platform';

export default {
  components,
  features: {
    auth,
    getting_ready: gettingReady,
    no_team: noTeam,
    platform,
  },
};
